<template>
  <div class="list-box bg-gray-100 rounded-lg">
    <div class="nav" title="HuiYiDetailHuiChangList" data-title="采购管理">
      <div class="flex flex-shrink-0 ml-3" style="flex: stretch">
        <c_cell title="总额">
          <c_money
            :key="state.statistics?.total_amount"
            :value="state.statistics?.total_amount"
            :prefix="false"
            bold
            color="#000"
          />
        </c_cell>
        <c_cell title="已付" class="ml-3">
          <template #default>
            <c_money
              :key="state.statistics?.total_paid_amount"
              :value="state.statistics?.total_paid_amount"
              :prefix="false"
              color="#080"
            />
          </template>
        </c_cell>
        <c_cell title="付款中" class="ml-3">
          <template #default>
            <c_money
              :key="state.statistics?.total_paying_amount"
              :value="state.statistics?.total_paying_amount"
              :prefix="false"
              color="#ffa500"
            />
          </template>
        </c_cell>
        <c_cell title="应付" class="ml-3 flex-1">
          <template #default>
            <c_statistics
              :key="state.statistics?.total_unpaid_amount"
              :value="state.statistics?.total_unpaid_amount"
              :prefix="false"
            />
          </template>
        </c_cell>
        <li
          v-if="state.select_count > 0"
          class="text-sm text-gray-400 flex items-center"
        >
          已选
          <strong class="text-orange-600 mx-1">{{ state.select_count }}</strong>
          条数据
          <el-button type="danger" link @click="onClearSelect">清空</el-button>
        </li>
        <el-input
          v-model="state.params.keywords"
          class="c-search-white mx-3 !w-56"
          clearable
          placeholder="关键字"
          @keyup.enter="onLoad()"
          @clear="onLoad()"
        >
          <template #suffix>
            <el-icon
              @click="onLoad()"
              color="#a2a2a2"
              title="搜索"
              class="font-bold cursor-pointer hover:opacity-60"
              ><Search
            /></el-icon>
          </template>
        </el-input>
        <el-button
          type="primary"
          icon="Plus"
          @click="
            delete state.selectId;
            state.showInfo = true;
          "
        >
          新建
        </el-button>
        <el-button
          type="warning"
          icon="Money"
          @click="onShowPay()"
          :disabled="!state.select_count"
        >
          申请付款
        </el-button>
        <el-button
          type="warning"
          icon="Document"
          link
          @click="state.showRecord = true"
        >
          申请记录
        </el-button>
      </div>
    </div>
    <div class="content c-table-box mt-2 bg-white rounded-lg p-2.5">
      <el-table
        :data="state.list_data"
        v-loading="!Array.isArray(state.list_data)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        row-key="id"
        ref="tableDom"
        @selection-change="onSelectChange"
        @row-click="onRowClick"
        @select-all="onSelectAll"
      >
        <el-table-column
          type="selection"
          :width="55"
          align="center"
          reserve-selection
          :selectable="onJudgeSelect"
        />
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />

        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="供应商" label2="联系人" />
          </template>
          <template #default="{ row }">
            <c_tabgroup
              :value2="row.intro"
              v-if="row.is_supplier_purchase == 1"
            >
              <template #top>
                <strong>{{ row.supplier?.name }}</strong>
                <text class="text-xs text-gray-400 ml-1">{{
                  row.supplier?.number
                }}</text>
              </template>
              <template #bottom>
                <ul class="flex gap-x-2">
                  <text>{{ row.supplier?.contact_name }}</text>
                  <c_sex
                    :value="row.supplier?.contact_title == '先生' ? '男' : '女'"
                  />
                  <text>{{ $phoneFormat(row.supplier?.contact_phone) }}</text>
                </ul>
              </template>
            </c_tabgroup>
            <text v-else>无供应商采购</text>
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div
              class="c-table-col-header"
              label1="采购单号"
              label2="类型/创建人"
            />
          </template>
          <template #default="{ row }">
            <c_tabgroup :value1="row.number">
              <template #bottom>
                <div class="flex items-center text-gray-400 text-xs gap-x-2">
                  <text class="text-sm text-gray-600">
                    {{ row?.add_admin_name }}
                  </text>
                  <text>{{ row?.add_department_name }}</text>
                  <text class="ml-1">{{ row?.create_time }} 创建</text>
                </div>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column
          label="采购说明"
          prop="intro"
          :width="160"
          align="center"
          :formatter="$tab_TextFormat"
        />
        <el-table-column label="采购价" :width="120" align="center">
          <template #default="{ row }">
            <text class="text-red-500">{{ $priceFormat(row.amount) }}</text>
          </template>
        </el-table-column>
        <el-table-column label="付款中" :width="120" align="center">
          <template #default="{ row }">
            <text class="text-green-600">{{
              $priceFormat(row.paying_amount)
            }}</text>
          </template>
        </el-table-column>
        <el-table-column label="已付" :width="120" align="center">
          <template #default="{ row }">
            <text class="text-blue-400">{{
              $priceFormat(row.paid_amount)
            }}</text>
          </template>
        </el-table-column>
        <el-table-column label="应付" :width="120" align="center">
          <template #default="{ row }">
            <text class="text-red-500 font-bold">{{
              $priceFormat(row.unpaid_amount)
            }}</text>
          </template>
        </el-table-column>
        <el-table-column label="最后操作人/时间" :width="160">
          <template #header>
            <div class="c-table-col-header" label1="最后操作人" label2="时间" />
          </template>
          <template #default="{ row }">
            <c_tabgroup :value2="row?.edit_time">
              <template #top>
                <text class="text-sm text-gray-600">
                  {{ row?.edit_admin_name }}
                </text>
                <text>{{ row?.edit_department_name }}</text>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" :width="260">
          <template #default="{ row }">
            <el-button
              type="warning"
              :icon="Edit"
              link
              @click.stop="
                state.selectId = row.id;
                state.showInfo = true;
              "
            >
              编辑
            </el-button>
            <el-button
              type="danger"
              :icon="Delete"
              link
              @click.stop="onDelete(row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
  </div>
  <el-dialog
    v-model="state.showInfo"
    :title="`${state.selectId ? '编辑' : '新建'}采购`"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showInfo = false;
      }
    "
    width="95%"
    style="height: 95%; max-height: 95%"
  >
    <c_info
      :meeting_id="props.meeting_id"
      :id="state.selectId"
      @close="
        state.showInfo = false;
        onLoad();
      "
    />
  </el-dialog>
  <el-dialog
    v-model="state.showPay"
    :title="
      '申请付款-' + (state.last_item?.is_supplier_purchase ? '供应商' : '个人')
    "
    class="c-el-dialog"
    :before-close="
      () => {
        state.showPay = false;
      }
    "
    width="60%"
    style="max-height: 80%"
    :modal="true"
  >
    <c_pay
      :meeting_id="props.meeting_id"
      :ids="state.select_ids"
      :supplier="
        state.last_item?.is_supplier_purchase
          ? state.last_item?.supplier || {}
          : {}
      "
      @confirm="onPayConfirm"
    />
  </el-dialog>
  <el-dialog
    v-model="state.showRecord"
    title="申请记录"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showRecord = false;
      }
    "
    width="95%"
    style="height: 90%; max-height: 90%"
  >
    <c_record
      :meeting_id="props.meeting_id"
      @close="state.showRecord = false"
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { meeting_purchase_page, meeting_purchase_delete } from "@/http/meeting";
import { onDeleteConfirm } from "@/utils/funcs";

import c_info from "./Info.vue";
import c_pay from "./Pay.vue";
import c_record from "./Record/List.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  props: {
    meeting_id: Number,
  },
  components: {
    c_info,
    c_pay,
    c_record,
  },
  setup(props) {
    const tableDom = ref(null);
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      state.params.meeting_id = props.meeting_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.list_data;
      meeting_purchase_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count, statistics } = res.data?.data;
          state.list_data = list;
          state.totalCount = count;
          state.statistics = statistics;
        }
      });
    };

    //删除
    const onDelete = (row) => {
      onDeleteConfirm(meeting_purchase_delete, row.id, onLoad, {
        filed: "采购单",
        name: row.number,
      });
    };

    //行点击事件
    const onRowClick = (item) => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.some((w) => w.id == item)) {
        tableDom.value.toggleRowSelection(item);
      } else {
        if (onJudgeSelect(item)) {
          tableDom.value.toggleRowSelection(item);
        }
      }
    };

    //选择项改变事件
    const onSelectChange = (e) => {
      state.select_count = e.length;
      if (e.length > 0) {
        state.last_item = e[0]; //记录最后一次选择的项目，列表的多选框根据最后选择的项来判断是否禁用，只有供应商id相同或者付款对象为个人的数据才可以同时选择
      } else {
        //如果列表项未勾选，清空最后选择的项目，方式最后一次选择项目记录上次选择，导致无法再选其他采购单
        state.last_item = {};
      }
    };

    //清空已选
    const onClearSelect = () => {
      tableDom.value.clearSelection();
      state.select_count = 0;
    };

    //验证列表每行的多选框是否可选
    const onJudgeSelect = (row) => {
      if (state.last_item?.id) {
        //如果最后选择项有值，则验证其他项是否与最后选择项匹配
        if (row.is_supplier_purchase == state.last_item?.is_supplier_purchase) {
          //如果当前选择项与最后选择项的付款对象相同时，均为个人或者供应商
          if (row.is_supplier_purchase == 0) {
            //如果当前选择项付款对象为个人时，则其他付款对象为个人的采购单均可选择
            return true;
          } else {
            //如果付款对象为供应商，则验证其他采购单的付款对象为同一个供应商的采购单可选
            return row.supplier_id == state.last_item?.supplier_id;
          }
        } else {
          //如果付款对象与最后一次选择项的付款对象不同，则不允许同时选择
          return false;
        }
      } else {
        //如果最后一次选择项为空，可能是第一次选择也可能清空的已选择项，把最后一项置为空，则当前所有采购单均可选择
        return true;
      }
    };

    const onSelectAll = (e) => {
      state.select_count = 0;
      if (!state.last_item?.id) {
        state.last_item = e[0];
      }

      e.forEach((row) => {
        if (row.paying_amount > 0) {
          tableDom.value.toggleRowSelection(row);
        } else {
          if (row.is_supplier_purchase != state.last_item?.is_supplier_purchase)
            //如果当前选择项与最后一次选择项的付款对象不同，则取消选择
            tableDom.value.toggleRowSelection(row);
          else {
            if (row.supplier_id != state.last_item?.supplier_id)
              //如果当前选择项的供应商id与最后一次选择项的供应商id不同，则取消选择
              tableDom.value.toggleRowSelection(row);
          }
        }
      });
    };

    const onShowPay = () => {
      const rows = tableDom.value.getSelectionRows();
      state.select_ids = rows.map((m) => m.id);
      state.showPay = true;
    };

    const onPayConfirm = () => {
      tableDom.value.clearSelection();
      onLoad();
      delete state.showPay;
    };

    return {
      state,
      props,
      tableDom,
      onLoad,
      onDelete,
      onClearSelect,
      onRowClick,
      onSelectChange,
      onJudgeSelect,
      onSelectAll,
      onShowPay,
      onPayConfirm,
    };
  },
};
</script>

<style lang="scss" scoped></style>
